<template>
  <div class="wrapper my-8 mx-8">
    <p>
      <span style="color:rgb(0,170,221);">
        <span style="cursor:pointer;" @click="$router.push('/')">Dashboard</span> /
        <span style="cursor:pointer" @click="$router.push('/doctors')">Doctors</span>
      </span>
      /
      {{selectedDoctor.userProfile.firstName}} {{selectedDoctor.userProfile.lastName}}
    </p>
    <v-icon class="mt-10"  @click="$router.push('/doctors')">
      mdi-arrow-left
    </v-icon>
    <div class="cell mt-10">
      <div class="d-flex">
        <div
          style="position:relative; width:30%"
          class="d-flex flex-column align-center pt-12 px-12"
        >
          <img
            :src="selectedDoctor.userProfile.profilePic"
            alt="testImg"
            style="height:100px;width:100px; border-radius:50%;"
          />

          <!-- <v-img :src="selectedDoctor.userProfile.profilePic"></v-img> -->
          <h3
            class="mt-3 text-center"
          >{{selectedDoctor.userProfile.firstName}} {{selectedDoctor.userProfile.lastName}}</h3>
          <p class="mt-3">{{selectedDoctor.userProfile.userName}}</p>
          <div class="pending mt-3" v-if="selectedDoctor.BORevisedStatus === 'pending'">
            <p class="px-4 white--text text-center">PENDING APPROVAL</p>
          </div>
          <div
            class="green mt-3"
            v-else-if="selectedDoctor.BORevisedStatus == 'accepted' && !selectedDoctor.userProfile.isBlocked"
          >
            <p class="px-4 white--text">ACTIVE</p>
          </div>
          <div class="blocked mt-3" v-else-if="selectedDoctor.userProfile.isBlocked">
            <p class="px-3 white--text">Blocked</p>
          </div>
          <div class="blocked mt-3" v-else-if="selectedDoctor.BORevisedStatus == 'rejected'">
            <p class="px-3 white--text">Rejected</p>
          </div>

          <!-- <div
            class="d-flex flex-column align-center justify-center my-12"
            v-if="selectedDoctor.BORevisedStatus == 'accepted'"
          >
            <h1 class="font-weight-bold">42%</h1>
            <p>availability last 10 days</p>
          </div> -->

          <p class="my-6 mb-12 text-center">
            Registration Request
            <span
              class="black--text"
            >{{convertDate(selectedDoctor.userProfile.createdAt)}}</span>
          </p>

          <div
            class="mt-12 d-flex flex-column align-center justify-center"
            v-if="selectedDoctor.BORevisedStatus=='rejected'"
          >
            <p>Changed your mind?</p>
            <div
              class="d-flex align-center justify-center mt-2"
              style="cursor:pointer;"
              @click="approveDialog = true"
            >
              <v-icon left color="rgb(130,215,74)">mdi-check-circle-outline</v-icon>
              <p class="black--text">Accept Doctor</p>
            </div>
          </div>

          <div

            class="pendingButtons d-flex flex-column flex-md-row align-center justify-center mt-12"
            v-if="selectedDoctor.BORevisedStatus == 'pending'"
          >
            <v-btn
              depressed
              rounded
              class="text-capitalize white--text mb-sm-2 mb-md-0"
              color="rgb(255,0,0)"
              @click="rejectDialog = true"
            >Reject</v-btn>
            <v-btn
              depressed
              rounded
              class="text-capitalize white--text ml-md-2"
              color="rgb(113,210,48)"
              @click="approveDialog = true"
            >Approve</v-btn>
          </div>

          <div
            style="position:absolute; bottom:0;"
            v-if="!selectedDoctor.userProfile.isBlocked && selectedDoctor.BORevisedStatus !== 'rejected' && selectedDoctor.BORevisedStatus !== 'pending'"
          >
            <v-btn
              class="text-capitalize"
              color="rgb(222,36,65)"
              text
              @click="blockDialog=true"
            >
            <img class="mr-2" style="height:20px; width: auto;" src="/img/ban.svg" alt="">
            Block user</v-btn>
          </div>

          <div
            style="position:absolute; bottom:0;"
            v-else-if="selectedDoctor.userProfile.isBlocked"
          >
            <v-btn class="text-capitalize" text @click="unblockDialog=true">
              <img src="/img/approve.svg" style="height:20px; width:auto;" class="mr-2" alt="">
              <p class="black--text">Unblock User</p>  
            </v-btn>
          </div>
        </div>
        <hr class="mr-10 my-10 " style="align-self:strech; border-color:rgb(242,242,242);" />
        <div class="d-flex flex-column content" style="flex:1">
          <v-tabs color="rgb(0,170,221)">
            <v-tab class="black--text">General Info</v-tab>
            <v-tab class="black--text" v-if="selectedDoctor.BORevisedStatus == 'accepted'">Activity</v-tab>
            <v-tab class="black--text" v-if="selectedDoctor.BORevisedStatus == 'accepted'">History</v-tab>

            <!-- GENERAL INFO TAB -->
            <v-tab-item>
              <!-- <div class="d-flex "> -->
              <!-- <div class="d-flex"> -->

              <v-container>
                <v-row>
                  <v-col sm="12" lg="6">
                   
                    <v-row no-gutters class="ml-3">
                      
                      <v-col cols="12">
                         <h4 class="mt-12 ml-n3">Personal Data</h4>
                        <v-row>
                          <v-col cols="6" class="pa-0">
                            <p>First Name:</p>
                          </v-col>
                          <v-col cols="6" class="pa-0">
                            <p
                              class="black--text"
                            >{{selectedDoctor.userProfile ? selectedDoctor.userProfile.firstName : ''}}</p>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col cols="6" class="pa-0">
                            <p>Last Name:</p>
                          </v-col>
                          <v-col cols="6" class="pa-0">
                            <p
                              class="black--text"
                            >{{selectedDoctor.userProfile ? selectedDoctor.userProfile.lastName : ''}}</p>
                          </v-col>
                        </v-row>

                        <!-- <v-row>
                          <v-col cols="6" class="pa-0">
                            <p>Username:</p>
                          </v-col>
                          <v-col cols="6" class="pa-0">
                            <p
                              class="black--text"
                            >{{selectedDoctor.userProfile ? selectedDoctor.userProfile.username : ''}}</p>
                          </v-col>
                        </v-row> -->

                        <v-row>
                          <v-col cols="6" class="pa-0">
                            <p>VAT number:</p>
                          </v-col>
                          <v-col cols="6" class="pa-0">
                            <p
                              class="black--text"
                            >{{selectedDoctor.userProfile ? selectedDoctor.userProfile.taxId : ''}}</p>
                          </v-col>
                        </v-row>
<!-- 
                        <v-row>
                          <v-col cols="6" class="pa-0">
                            <p>KAD:</p>
                          </v-col>
                          <v-col cols="6" class="pa-0">
                            <div v-if="!!selectedDoctor.KADs" class="d-flex flex-column">
                              <p class="black--text">{{!!kyriaKad ? kyriaKad.code : ''}}</p>
                              <p class="black--text">{{!!kyriaKad ? kyriaKad.description : ''}}</p>
                              <v-btn
                                small
                                v-if="selectedDoctor.KADs.length > 1"
                                text
                                width="150"
                                color="rgb(0,169,221)"
                                class="text-capitalize pa-0"
                                @click="kadDialog=true"
                              >
                                <v-icon left>mdi-plus</v-icon>
                                view {{selectedDoctor.KADs.length}} more codes
                              </v-btn>
                            </div>
                            <v-btn
                              text
                              color="rgb(0,169,221)"
                              class="text-capitalize pa-0"
                              v-else
                              @click="searchNewKad"
                            >
                              <v-icon left>mdi-magnify</v-icon>Search in TAXISnet
                            </v-btn>
                          </v-col>
                        </v-row> -->

                        <!-- <v-row>
                          <v-col cols="6" class="pa-0">
                            <p>Date of Birth:</p>
                          </v-col>
                          <v-col cols="6" class="pa-0">
                            <p
                              class="black--text"
                            >{{selectedDoctor.userProfile ? convertDate(selectedDoctor.userProfile.birthDate) : ''}}</p>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col cols="6" class="pa-0">
                            <p>Gender:</p>
                          </v-col>
                          <v-col cols="6" class="pa-0">
                            <p
                              class="black--text"
                            >{{selectedDoctor.userProfile ? convertGender(selectedDoctor.userProfile.gender) : ''}}</p>
                          </v-col>
                        </v-row> -->

                        <v-row>
                          <v-col cols="6" class="pa-0">
                            <p>Country:</p>
                          </v-col>
                          <v-col cols="6" class="pa-0">
                            <p
                              class="black--text"
                            >{{selectedDoctor.userProfile ? selectedDoctor.userProfile.homeCountryName : ''}}</p>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col cols="6" class="pa-0">
                            <p>Mobile:</p>
                          </v-col>
                          <v-col cols="6" class="pa-0">
                            <p
                              class="black--text"
                            >{{selectedDoctor.userProfile ? selectedDoctor.userProfile.mobile : ''}}</p>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col cols="6" class="pa-0">
                            <p style="white-space: nowrap;">Registration Email:</p>
                          </v-col>
                          <v-col cols="6" class="pa-0">
                            <p
                              class="black--text"
                            >{{selectedDoctor.userProfile ? selectedDoctor.userProfile.email : ''}}</p>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col cols="6" class="pa-0">
                            <p style="white-space: nowrap;">Registration Date:</p>
                          </v-col>
                          <v-col cols="6" class="pa-0">
                            <p
                              class="black--text"
                            >{{selectedDoctor.userProfile ? convertDate(selectedDoctor.userProfile.createdAt) : ''}}</p>
                          </v-col>
                        </v-row>

                      
<!-- 
                        <v-row>
                          <v-col cols="6" class="pa-0">
                            <p>Language(s):</p>
                          </v-col>
                          <v-col cols="6" class="pa-0">
                            <div>
                              <p
                                class="black--text d-flex flex-row"
                                v-for="(language,index) in selectedDoctor.userProfile.spokenLanguages"
                                :key="index"
                              >
                                {{language.languageName}}
                                <span
                                  v-if="!(index === selectedDoctor.userProfile.spokenLanguages.length - 1)"
                                >,</span>
                              </p>
                            </div>
                          </v-col>
                        </v-row>
                         -->
                        

                        <h4 class="mt-12 ml-n3">Healthcare Professional Information</h4>
                        <!-- <v-row no-gutters class="ml-3">
                          <v-col cols="12"> -->
                            <v-row>
                              <v-col cols="6" class="pa-0">
                                <p>Type of Doctor:</p>
                              </v-col>
                              <v-col cols="6" class="pa-0">
                                <p
                                  class="black--text"
                                >{{selectedDoctor.doctorAccredations ? selectedDoctor.doctorAccredations.doctorTypeName : ''}}</p>
                              </v-col>
                            </v-row>

                              <v-row>
                          <v-col cols="6" class="pa-0">
                            <p style="white-space: nowrap;">Public Doctor:</p>
                          </v-col>
                          <v-col cols="6" class="pa-0">
                            <p
                              class="black--text"
                            >{{selectedDoctor.isPublicSectorEmployee ? 'Yes' : 'No'}}</p>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col cols="6" class="pa-0">
                            <p style="white-space: nowrap;">Medical Association:</p>
                          </v-col>
                          <v-col cols="6" class="pa-0">
                            <p
                              class="black--text"
                            >{{selectedDoctor.doctorAccredations ? selectedDoctor.doctorAccredations.docMedicalAssociation : ''}}</p>
                          </v-col>
                        </v-row>
<!-- 
                            <v-row>
                              <v-col cols="6" class="pa-0">
                                <p>Registration No:</p>
                              </v-col>
                              <v-col cols="6" class="pa-0">
                                <p
                                  class="black--text"
                                >{{selectedDoctor.doctorAccredations ? selectedDoctor.doctorAccredations.docRegistrationNo : ''}}</p>
                              </v-col>
                            </v-row>

                            <v-row>
                              <v-col cols="6" class="pa-0">
                                <p>Specialization:</p>
                              </v-col>
                              <v-col cols="6" class="pa-0">
                                <p
                                  class="black--text"
                                >{{selectedDoctor.doctorAccredations ? selectedDoctor.doctorAccredations.docSpecialization : ''}}</p>
                              </v-col>
                            </v-row>

                            <v-row>
                              <v-col cols="6" class="pa-0">
                                <p>University:</p>
                              </v-col>
                              <v-col cols="6" class="pa-0">
                                <p
                                  class="black--text"
                                >{{selectedDoctor.doctorAccredations ? selectedDoctor.doctorAccredations.docEduInstitutionName : ''}}</p>
                              </v-col>
                            </v-row>

                            <v-row>
                              <v-col cols="6" class="pa-0">
                                <p style="white-space: nowrap;">Graduation Year:</p>
                              </v-col>
                              <v-col cols="6" class="pa-0">
                                <p
                                  class="black--text"
                                >{{selectedDoctor.doctorAccredations ? selectedDoctor.doctorAccredations.docEduBaseGradYear : ''}}</p>
                              </v-col>
                            </v-row>

                            <v-row>
                              <v-col cols="6" class="pa-0">
                                <p style="white-space: nowrap;">Specialization Year:</p>
                              </v-col>
                              <v-col cols="6" class="pa-0">
                                <p
                                  class="black--text"
                                >{{selectedDoctor.doctorAccredations ? selectedDoctor.doctorAccredations.docEduSpecialtyGradYear : ''}}</p>
                              </v-col>
                            </v-row>

                            <v-row>
                              <v-col cols="6" class="pa-0">
                                <p style="white-space: nowrap;">Medical Association:</p>
                              </v-col>
                              <v-col cols="6" class="pa-0">
                                <p
                                  class="black--text"
                                >{{selectedDoctor.doctorAccredations ? selectedDoctor.doctorAccredations.docMedicalAssociation : ''}}</p>
                              </v-col>
                            </v-row> -->

                            <v-row>
                              <v-col cols="6" class="pa-0">
                                <p
                                  v-if="selectedDoctor.doctorAccredations.idNumberType === 'amka'"
                                >ΑΜ:</p>
                                <p
                                  v-else-if="selectedDoctor.doctorAccredations.idNumberType === 'tsay'"
                                >ΤΣΑΥ</p>
                                <p
                                  v-else-if="selectedDoctor.doctorAccredations.idNumberType === 'medassoc'"
                                >Medical Association:</p>
                              </v-col>
                              <v-col cols="6" class="pa-0">
                                <p
                                  class="black--text"
                                >{{selectedDoctor.doctorAccredations ? selectedDoctor.doctorAccredations.idNumber : ''}}</p>
                              </v-col>
                            </v-row>
                          <!-- </v-col>
                        </v-row> -->

                        <!-- <h4 class="mt-12 ml-n3">Interested in</h4> -->
                        <!-- <v-row no-gutters class="pb-12 ml-3">
                          <v-col cols="12"> -->
                            <!-- <v-row>
                              <v-col cols="6" class="pa-0">
                                <p>Emergency care:</p>
                              </v-col>
                              <v-col cols="6" class="pa-0">
                                <p class="black--text">
                                  <span v-if="selectedDoctor.scopeEmergencyCare">Yes</span>
                                  <span v-else>No</span>
                                </p>
                              </v-col>
                            </v-row>

                            <v-row>
                              <v-col cols="6" class="pa-0">
                                <p>Outpatient visits at clients premises:</p>
                              </v-col>
                              <v-col cols="6" class="pa-0">
                                <p class="black--text">
                                  <span v-if="selectedDoctor.scopeHomeAppointments">Yes</span>
                                  <span v-else>No</span>
                                </p>
                              </v-col>
                            </v-row>

                            <v-row>
                              <v-col cols="6" class="pa-0">
                                <p>Outpatient visits at doctor's office:</p>
                              </v-col>
                              <v-col cols="6" class="pa-0">
                                <p class="black--text">
                                  <span v-if="selectedDoctor.scopeOfficeAppointments">Yes</span>
                                  <span v-else>No</span>
                                </p>
                              </v-col>
                            </v-row> -->
                          </v-col>
                        <!-- </v-row>
                      </v-col> -->
                    </v-row>
                  </v-col>
                  <v-col sm="12" lg="6">
                 
                      <h4 class="mt-12">Private / surgery office</h4>
                      <v-row>
                        <v-col cols="6">
                          <p>Private / surgery office</p>
                          <p>Address</p>
                          <p>Telephone</p>
                          <p>Working hours / days</p>
                        </v-col>
                        <v-col cols="6">
                          <p class="black--text">TODO</p>
                          <p
                            class="black--text"
                          >{{selectedDoctor.companyProfile.addressProfile.address}}</p>
                          <p class="black--text">{{selectedDoctor.companyProfile.phoneNo}}</p>
                          <div
                            v-for="(workDay, index) in selectedDoctor.officeWorkingHours"
                            :key="index"
                          >
                            <p
                              class="black--text"
                            >{{convertDay(workDay.weekday)}} {{convertHour(workDay.start)}} - {{convertHour(workDay.end)}}</p>
                          </div>
                        </v-col>
                      </v-row>

                      <!-- <h4>Other Information</h4>
                      <v-row>
                        <v-col cols="6">
                          <p>Civil liabilitty insured:</p>
                          <p>Medical Equipment:</p>
                        </v-col>
                        <v-col cols="6">
                          <p class="black--text">
                            <span v-if="selectedDoctor.isCivilLiabilityInsured">Yes</span>
                            <span v-else>No</span>
                          </p>
                          <p class="black--text">{{selectedDoctor.medicalEquipment}}</p>
                        </v-col>
                      </v-row>

                      <h4>Different</h4>
                      <v-row>
                        <v-col cols="6">
                          <p class="bold">Awards</p>
                          <p>{{selectedDoctor.awards}}</p>

                          <p class="bold mt-5">Social Profile</p>
                          <p>
                            LinkedIn:
                            <span class="black--text">{{selectedDoctor.linkedin}}</span>
                          </p>

                          <p class="bold mt-5">Photos</p>
                        </v-col>
                      </v-row> -->
                 
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>

            <!-- ACTIVITY TAB -->
            <v-tab-item>Activity</v-tab-item>

            <!-- HISTORY TAB -->
            <v-tab-item>
              <div class="d-flex flex-column">
                <p class="mt-10">October 15, 2019</p>
                <div class="d-flex align-center mt-5">
                  <p>img</p>
                  <div class="d-flex flex-column mr-12">
                    <p class="bold">Hester Manning</p>
                    <p>Blocked account</p>
                  </div>
                  <p class="ml-12">16:31pm</p>
                </div>

                <p class="mt-10">October 15, 2019</p>
                <div class="d-flex align-center mt-5">
                  <p>img</p>
                  <div class="d-flex flex-column mr-12">
                    <p class="bold">Hester Manning</p>
                    <p>Blocked account</p>
                  </div>
                  <p class="ml-12">16:31pm</p>
                </div>
              </div>
            </v-tab-item>
          </v-tabs>
        </div>
      </div>
    </div>

    <v-dialog v-model="rejectDialog" width="600">
      <v-card class="pt-12">
        <v-card-text>
          <div class="d-flex flex-column align-center justify-center">
            <h1
              class="text-center"
            >Reject {{selectedDoctor.userProfile.salutation}}. {{selectedDoctor.userProfile.firstName}} {{selectedDoctor.userProfile.lastName}}?</h1>
            <p
              class="text-center mt-4"
            >Prevent this user from being able to receive any emergency or appointment requests from patients and access your network.</p>
            <p
              class="text-center mt-3"
            >However they will be still allowed to login and make changes to their profile and personal info.</p>
          </div>
          <div class="d-flex justify-center mt-4">
            <v-btn
              class="text-capitalize mr-2"
              outlined
              color="rgb(164,164,164)"
              rounded
              @click="rejectDialog=false"
            >Cancel</v-btn>
            <v-btn
              class="text-capitalize white--text"
              color="rgb(255,0,0)"
              depressed
              rounded
              @click="reject"
            >Reject</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="approveDialog" width="600">
      <v-card class="pt-12">
        <v-card-text>
          <div class="d-flex flex-column align-center justify-center">
            <h1
              class="text-center"
            >Approve {{selectedDoctor.userProfile.salutation}}. {{selectedDoctor.userProfile.firstName}} {{selectedDoctor.userProfile.lastName}}?</h1>
            <p
              class="text-center mt-4"
            >This user will be considered as a trusted doctor and will be able to receive emergency requests, book appointments with patients and access your network.</p>
          </div>
          <div class="d-flex justify-center mt-4">
            <v-btn
              class="text-capitalize mr-2"
              outlined
              color="rgb(164,164,164)"
              rounded
              @click="approveDialog=false"
            >Cancel</v-btn>
            <v-btn
              class="text-capitalize white--text"
              color="rgb(113,210,48)"
              depressed
              rounded
              @click="approve"
            >Approve</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="blockDialog" width="600">
      <v-card class="pt-12">
        <v-card-text>
          <div class="d-flex flex-column align-center justify-center">
            <h1
              class="text-center"
            >Block {{selectedDoctor.userProfile.salutation}}. {{selectedDoctor.userProfile.firstName}} {{selectedDoctor.userProfile.lastName}}?</h1>
            <p class="text-center mt-4">
              Prevent this user from being able to receive emergency or appointments requests.
              However they will be still allowed to login to make changes to their profile and personal info or access previous cases.
            </p>
          </div>
          <div class="d-flex justify-center mt-4">
            <v-btn
              class="text-capitalize mr-2"
              outlined
              color="rgb(164,164,164)"
              rounded
              @click="blockDialog=false"
            >cancel</v-btn>
            <v-btn
              class="text-capitalize white--text"
              rounded
              color="rgb(255,0,0)"
              @click="block"
            >block</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="unblockDialog" width="600">
      <v-card class="pt-12">
        <v-card-text>
          <div class="d-flex flex-column align-center justify-center">
            <h1
              class="text-center"
            >Unblock {{selectedDoctor.userProfile.salutation}}. {{selectedDoctor.userProfile.firstName}} {{selectedDoctor.userProfile.lastName}}?</h1>
            <p
              class="text-center mt-4"
            >This user will be re-activated and able to use your services again (receive emergency requests, appointments etc).</p>
          </div>
          <div class="d-flex justify-center mt-4">
            <v-btn
              class="text-capitalize mr-2"
              outlined
              color="rgb(164,164,164)"
              rounded
              @click="unblockDialog=false"
            >cancel</v-btn>
            <v-btn
              class="text-capitalize white--text"
              rounded
              color="rgb(113,210,48)"
              @click="unblock"
            >Unblock</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="kadDialog" width="700">
      <v-card class="px-12 pt-10">
        <v-card-text>
          <div class="d-flex flex-column align-center justify-center">
            <h1 class="text-center black--text">KAD codes for VAT number: {{selectedDoctor.taxId}}</h1>
            <p class="mt-3">Results from TAXISnet database</p>
            <div class="d-flex flex-column mt-5">
              <div
                class="d-flex justify-space-between"
                v-for="(kad, index) in selectedDoctor.KADs"
                :key="index"
              >
                <p class="mr-12 mt-2 black--text">{{kad.code}}</p>
                <p class="text-right mt-2">{{kad.description}}</p>
              </div>
            </div>
            <v-btn
              text
              color="rgb(0,169,221)"
              class="text-capitalize mt-4"
              :loading="taxisLoading"
              @click="searchNewKad"
            >
              <v-icon left small>mdi-magnify</v-icon>Search again in TAXISnet
            </v-btn>
            <v-btn
              rounded
              outlined
              class="text-capitalize mt-4"
              color="rgb(107,107,107)"
              @click="kadDialog=false"
            >Close</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      taxisLoading: false,
      kadDialog: false,
      approveDialog: false,
      rejectDialog: false,
      blockDialog: false,
      unblockDialog: false,
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ]
    };
  },
  methods: {
    searchNewKad() {
      this.taxisLoading = true;
      this.$store
        .dispatch("updateKad", {
          entityId: this.selectedDoctor.doctorID,
          taxId: this.selectedDoctor.userProfile.taxId
        })
        .then(res => {
          console.log(res);
          this.taxisLoading = false;
        })
        .catch(err => {
          console.log(err);
          this.taxisLoading = false;
        });
    },
    convertDate(date2) {
      const date = new Date(date2);
      const day = date.getDate();
      const month = date.getMonth();
      const year = date.getFullYear();
      return day + " " + this.months[month].substr(0, 3) + " " + year;
    },
    convertDay(day) {
      if (day === "mon") return "Monday";
      if (day === "tue") return "Tuesday";
      if (day === "wed") return "Wednesday";
      if (day === "thu") return "Thursday";
      if (day === "fri") return "Friday";
      if (day === "sat") return "Saturday";
      if (day === "sun") return "Sunday";
    },
    convertHour(hour) {
      const myHour = hour;
      if (hour < 12) {
        return myHour.toString() + "am";
      } else {
        return myHour.toString() + "pm";
      }
    },
    convertGender(gender) {
      if (gender == "m") return "male";
      if (gender == "f") return "female";
      return "other";
    },
    reject() {
      const credentials = {
        doctorId: this.$route.params.id,
        BORevisedStatus: "rejected"
      };
      this.$store.dispatch("rejectDoctor", credentials).then(() => {
        this.rejectDialog = false;
      });
    },

    approve() {
      const credentials = {
        doctorId: this.$route.params.id,
        BORevisedStatus: "accepted"
      };
      this.$store.dispatch("approveDoctor", credentials).then(() => {
        this.approveDialog = false;
      });
    },
    block() {
      const credentials = {
        userId: this.selectedDoctor.userProfile.userId,
        isBlocked: true
      };
      this.$store.dispatch("blockDoctor", credentials).then(() => {
        this.blockDialog = false;
      });
    },
    unblock() {
      const credentials = {
        userId: this.selectedDoctor.userProfile.userId,
        isBlocked: false
      };
      this.$store.dispatch("unblockDoctor", credentials).then(() => {
        this.unblockDialog = false;
      });
    }
  },
  computed: {
    selectedDoctor() {
      return this.$store.state.doctors.doctors.find(
        doctor => doctor.doctorID === this.$route.params.id
      );
    },
    kyriaKad() {
      if (!!this.selectedDoctor.KADs) {
        return this.selectedDoctor.KADs.find(main => main.kindCode == 1);
      } else {
        return null;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.pendingButtons{
  @media only screen and (max-width: 600px){
    display: flex;
    flex-direction: column;
  }
}
</style>